import React, { useCallback, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import GroupAssetList from './GroupAssetList';
import GroupAssetModal from './GroupAssetModal';
import { useAuth0 } from '@auth0/auth0-react';

const GroupAssetPage = () => {
    const { groupId } = useParams();
    const [assets, setAssets] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState(null);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    // Fetch assets data from the API or your backend
    const fetchAssets = useCallback(async () => {
        try {
            const token = await getAccessTokenSilently({
                authorizationParams: {
                    audience: process.env.REACT_APP_API_AUDIENCE,
                }
            });

            const response = await fetch(`${apiUrl}/api/assets/group/${groupId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            const data = await response.json();
            setAssets(data);
        } catch (error) {
            console.error('Error fetching assets:', error);
        }
    }, [apiUrl, getAccessTokenSilently, groupId]);

    // Fetch assets on component mount and when the modal is closed
    useEffect(() => {
        fetchAssets();
    }, [groupId, showAddModal, fetchAssets]);


    const handleAddAssetClick = () => {
        setShowAddModal(true);
    };

    const handleAssetCardClick = (asset) => {
        setSelectedAsset(asset);
    };

    const handleCloseModal = () => {
        setSelectedAsset(null);
        setShowAddModal(false);
    };

    /*
     
    */ 
   
    return (
        <main className="tyk-page">
            <div className="tyk-page-shell">
            <section className="tyk-hero-panel">
                <div>
                    <span className="tyk-kicker">Group marketplace</span>
                    <h1 className="tyk-hero-title">Group Assets</h1>
                    <p className="tyk-hero-copy">
                        Manage shared inventory, marketplace listings, trade availability, and member access from one group-owned collection.
                    </p>
                </div>

                <Button variant="primary" onClick={handleAddAssetClick} className="tyk-action">
                    Add Asset
                </Button>
            </section>
           
            <section className="tyk-panel">
            <GroupAssetList assets={assets} onAssetCardClick={handleAssetCardClick} />
            </section>

            <GroupAssetModal
                show={showAddModal}
                onHide={() => setShowAddModal(false)}
                asset={null} // Pass null for new asset
                groupId={groupId}
                onAssetAdded={fetchAssets} 
            />
     
            {selectedAsset && (
                <Modal show={!!selectedAsset} onHide={handleCloseModal} className="tyk-modal" centered size="lg">
                    <Modal.Header closeButton closeVariant="white">
                        <div>
                            <span className="tyk-kicker">Asset detail</span>
                            <Modal.Title>{selectedAsset.assetName}</Modal.Title>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="tyk-panel">
                            <p className="text-slate-200">{selectedAsset.assetDescription || 'No description has been added yet.'}</p>
                            <div className="tyk-stat-row mt-3">
                                <div className="tyk-stat">
                                    <span>Quantity</span>
                                    <strong>{selectedAsset.quantity ?? 'N/A'}</strong>
                                </div>
                                <div className="tyk-stat">
                                    <span>Location</span>
                                    <strong className="text-base">{selectedAsset.location || 'Not set'}</strong>
                                </div>
                                <div className="tyk-stat">
                                    <span>Status</span>
                                    <strong className="text-base">{selectedAsset.availability ? 'Available' : 'Unavailable'}</strong>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            )}
            </div>
        </main>
    );
};

export default GroupAssetPage;

